import script from "./CaptchaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptchaInput.vue?vue&type=script&setup=true&lang=js"

import "./CaptchaInput.vue?vue&type=style&index=0&id=1cbf55d5&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"CaptchaInput.vue"]])

export default __exports__